import {parseParams, XHR_STATUS_DEFAULT} from '@/utils/portuna';
import dateHelper from '@/utils/portuna/dateHelper';
import {ref, watch, computed, type Ref} from 'vue';
import axios from 'axios';

export function useDatePicker(
    showHolidays: Ref<Optional<boolean>>,
    blockHolidays: Ref<Optional<boolean>>,
    holidayState: Ref<Optional<string>>,
    holidayPostcode: Ref<Optional<string>>,
    holidayAddress: Ref<Optional<number>>,
)
{
    // {year: {day: name}}
    const holidays         = ref<Record<string, Record<string, string>>>({});
    const holidaysFetching = ref<Record<string, boolean>>({});

    const selectedDate   = ref<string>('');
    const selectedYear   = ref<number>(0);
    const selectedMonth  = ref<number>(0);
    const selectedDay    = ref<number>(0);
    const selectedHour   = ref<number>(0);
    const selectedMinute = ref<number>(0);

    const useHolidays = computed(() => showHolidays.value || blockHolidays.value);

    const yearHolidays = computed(() => holidays.value[holidayParamId.value!]);

    const holidayParamId = computed(() => parseParams(holidayParams.value!));

    const holidayParams = computed(() => ({
        year: selectedYear.value,
        state: holidayState.value!,
        postcode: holidayPostcode.value!,
        address: holidayAddress.value!,
    }));

    function getHolidayInfo(date: Date)
    {
        const dateISO   = dateHelper('Y-m-d', date) as string;
        const isHoliday = !!(useHolidays.value && yearHolidays.value[dateISO]);

        return {
            isHoliday,
            holidayTitle: isHoliday ? `<strong>Feiertag:</strong><br>` + yearHolidays.value[dateISO] : '',
            blocked: isHoliday && blockHolidays.value,
        };
    }

    function fetchHolidays()
    {
        if (holidays.value![holidayParamId.value!] || holidaysFetching.value![holidayParamId.value!])
        {
            return;
        }

        holidaysFetching.value![holidayParamId.value!] = true;

        axios.get('/application/ajax/fetch-holidays' + holidayParamId.value!).then(response =>
        {
            if (response.data.status !== XHR_STATUS_DEFAULT)
            {
                throw response;
            }

            holidays.value![holidayParamId.value!] = response.data.data.days;
        })
        .catch(console.error);
    }

    watch(holidayParamId, () =>
    {
        if (useHolidays.value!)
        {
            fetchHolidays();
        }
    });

    return {
        selectedDate,
        selectedYear,
        selectedMonth,
        selectedDay,
        selectedHour,
        selectedMinute,
        useHolidays,
        yearHolidays,
        holidayParamId,
        holidayParams,
        getHolidayInfo,
        fetchHolidays,
    };
}